import { useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Eyebrow } from "@/components/site/Motion";

const SPACES = [
  { img: "/img/real-hotel-spaniel.jpg", t: "Hotel", d: "Espaços individuais, limpos e confortáveis para cada cão se sentir em casa." },
  { img: "/img/real-parque-piscina.jpg", t: "Parques Exteriores e Parques Interiores", d: "Espaços ao ar livre e cobertos para correr, brincar e socializar em segurança." },
  { img: "/img/treino-collie.jpg", t: "Área de treino", d: "Espaço dedicado a obediência, foco e exercícios de agilidade." },
  { img: "/img/banho-1.jpg", t: "Sala de banhos", d: "Banhos, secagem e tosquia num ambiente calmo e higienizado." },
];

const Frame = ({ s, i }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState({ x: 50, y: 50 });
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    setPos({ x: ((e.clientX - r.left) / r.width) * 100, y: ((e.clientY - r.top) / r.height) * 100 });
  };
  return (
    <Reveal>
      <figure ref={ref} data-testid={`facility-${i}`} className={i % 2 ? "lg:ml-auto lg:w-[86%]" : "lg:w-[92%]"}>
        <div onMouseMove={onMove} className="group relative aspect-[4/3] overflow-hidden [clip-path:polygon(0_0,100%_0,100%_88%,90%_100%,0_100%)]">
          <motion.img style={{ y }} src={s.img} alt={s.t} className="absolute inset-0 h-[116%] w-full -translate-y-[8%] object-cover" />
          <div
            className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100"
            style={{ background: `radial-gradient(circle 260px at ${pos.x}% ${pos.y}%, transparent 0%, rgba(8,9,11,0.75) 100%)` }}
          />
          <span className="absolute left-5 top-5 rounded-full bg-[#C8D484] px-3 py-1 font-mono text-[11px] font-medium uppercase tracking-widest text-black">0{i + 1}</span>
        </div>
        <figcaption className="mt-5 flex flex-col gap-1 sm:flex-row sm:items-baseline sm:gap-6">
          <span className="font-display text-3xl font-semibold uppercase">{s.t}</span>
          <span className="text-sm text-white/70">{s.d}</span>
        </figcaption>
      </figure>
    </Reveal>
  );
};

export const Facilities = () => (
  <section data-testid="facilities-section" className="border-t border-white/10 bg-[#0d0e11]">
    <div className="mx-auto grid max-w-[1440px] gap-14 px-5 py-24 sm:px-8 sm:py-32 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-4">
        <div className="lg:sticky lg:top-32">
          <Reveal>
            <Eyebrow>As instalações</Eyebrow>
            <h2 className="mt-5 font-display text-5xl font-semibold uppercase leading-[0.85] tracking-tight sm:text-7xl">
              Pensadas para <span className="font-serif font-normal normal-case italic tracking-normal text-[#C8D484]">cães.</span> Ao detalhe.
            </h2>
            <p className="mt-8 max-w-sm text-white/75">
              Em Palmeira, Braga, criámos um espaço onde cada zona tem um propósito: descansar, brincar, aprender e cuidar. Venha conhecê-lo pessoalmente.
            </p>
          </Reveal>
        </div>
      </div>
      <div className="flex flex-col gap-20 lg:col-span-8">
        {SPACES.map((s, i) => <Frame key={s.t} s={s} i={i} />)}
      </div>
    </div>
  </section>
);
